import {useQuery} from "@apollo/client";
import {
    CentralReportListResponse,
    GET_REPORT_LISTING_FOR_CENTRAL,
    ReportFileType,
} from "../graphql/queries/getReportFileListingForCentral";
import {useEffect, useState} from "react";
import {formatTimeRangeToISO} from "../../../../utils/dateTimeUtils";

export interface ReportFileFiltersType {
    type?: number;
    name?: string;
    reportDate?: [string | null, string | null] | null;
    operatorId?: number;
}

export interface ReportQueryResult {
    reportFileData: ReportFileType[];
    loading: boolean;
    refetch: (variables?: any) => Promise<any>;
    totalElements: number;
    buildQueryVariables: () => any;
}

export const useCentralReportFileQuery = (
    filters: ReportFileFiltersType,
    currentPage: number,
    pageSize: number,
    skip: boolean = false,
    warehouseId?: string | number
): ReportQueryResult => {
    const [reportFileData, setReportFileData] = useState<ReportFileType[]>([]);
    const [loading, setLoading] = useState(true);
    const [total, setTotal] = useState(0);

    const buildQueryVariables = () => {
        const timeRanges = {
            reportDate: formatTimeRangeToISO(filters.reportDate),
        };

        const queryFilters = {
            ...filters,
            ...timeRanges
        };

        return {
            warehouseId,
            filters: queryFilters,
            pageRequest: {
                page: currentPage,
                size: pageSize,
                sortBy: "createdAt",
                sortDirection: "DESC"
            }
        };
    };

    // 执行查询，当skip为true或仓库未就绪时跳过查询
    const { data, loading: queryLoading, refetch } = useQuery<CentralReportListResponse>(GET_REPORT_LISTING_FOR_CENTRAL,
        {
            variables: buildQueryVariables(),
            skip: skip || !warehouseId
        });

    // 当数据变化时更新状态
    useEffect(() => {
        if (data?.getReportFileListingForPickup) {
            const responseData = data.getReportFileListingForPickup.content || [];
            setReportFileData(responseData);
            setLoading(false);

            // GraphQL Long 类型会被序列化为字符串，需要转换
            const totalElements = parseInt(data.getReportFileListingForPickup.totalElements.toString()) || 0;
            setTotal(totalElements);
        }
    }, [data]);

    return {
        reportFileData,
        loading: loading || queryLoading,
        refetch,
        totalElements: total,
        buildQueryVariables
    };
}; 